/**
 * Leviathan Web - Completed Today Widget
 * Quasar Prime LLC
 * Aggressive Tactical Industrial Design
 *
 * Shows completed dispatches today count
 */

import { useState, useEffect } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { Activity } from 'lucide-react';
import { API_URL } from '@/config/api';

const CompletedTodayWidget = () => {
  const { accessToken } = useAuth();
  const [completedCount, setCompletedCount] = useState(0);
  const [totalToday, setTotalToday] = useState(0);
  const [ordersToday, setOrdersToday] = useState(0);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${API_URL}/api/analytics/dashboard`, {
          headers: { Authorization: `Bearer ${accessToken}` },
        });
        if (response.ok) {
          const data = await response.json();
          setCompletedCount(data.dashboard?.kpis?.completedToday ?? 0);
          setTotalToday(data.dashboard?.kpis?.dispatchesToday ?? 0);
          setOrdersToday(data.dashboard?.kpis?.ordersToday ?? 0);
        }
      } catch {
        // silent
      }
    };
    fetchData();
  }, [accessToken]);

  const completionRate = totalToday > 0 ? Math.round((completedCount / totalToday) * 100) : 0;

  return (
    <div className="h-full flex flex-col">
      <div className="flex items-center space-x-2 mb-3">
        <Activity className="w-4 h-4 text-success-green" />
        <span className="text-[10px] uppercase tracking-[0.15em] text-text-secondary font-mono">
          Completed Today
        </span>
      </div>

      <div
        className="text-3xl font-mono font-bold text-success-green mb-1"
        style={{ textShadow: '0 0 15px rgba(74,222,128,0.6)' }}
      >
        {completedCount}
      </div>
      <div className="text-text-tertiary text-xs font-mono mb-4">
        dispatches completed
      </div>

      <div className="space-y-3 mt-auto">
        {/* Completion rate */}
        <div>
          <div className="flex justify-between text-[10px] font-mono text-text-tertiary mb-1">
            <span>Completion Rate</span>
            <span className="text-success-green">{completionRate}%</span>
          </div>
          <div className="h-2 bg-background rounded-sm overflow-hidden">
            <div
              className="h-full bg-success-green transition-all"
              style={{
                width: `${completionRate}%`,
                boxShadow: '0 0 6px rgba(74,222,128,0.6)',
              }}
            />
          </div>
        </div>

        {/* Orders today */}
        <div className="flex justify-between text-[10px] font-mono">
          <span className="text-text-tertiary">Orders Today</span>
          <span className="text-amber">{ordersToday}</span>
        </div>
      </div>
    </div>
  );
};

export default CompletedTodayWidget;
